// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Nigeria from '../_raw/flag/icon_flag_nigeria.png';

export default () => <img src={Nigeria} alt="Nigeria" />;
